<template>
  <div class="container">
    <transition-group name="fade-out-left" tag="div" class="row" :css="!loading">
      <div class="col-sm-6 col-lg-4 col-xl-3" :class="{'col-6': !isPaid}" v-for="(media, index) in medias"
           :key="media.id">
        <Media :media="media"
               :index="index"
               :is-paid="isPaid"
               :digital-item-id="digitalItemId"
               :gallery="gallery"
               @firstVisible="$emit('nextPage')"
               @select="$emit('select', $event)"/>
      </div>
    </transition-group>

    <div style="height: 36px" class="text-center mt-2 mb-4" v-if="paginationMode === paginationType.INFINITE">
      <PaginationInfinite :loading="loading" :pagination="pagination" @nextPage="$emit('nextPage')"/>
    </div>
    <div class="overflow-auto d-flex justify-content-center" style="margin: 30px 0"
         v-if="paginationMode === paginationType.NUMBER">
      <PaginationNumber :pagination="pagination" @page-change="onPageChange"/>
    </div>
  </div>
</template>

<script>
import Media from "@/domain/galleries/medias/Media.vue";
import {paginationType} from "@/domain/galleries/constants";
import PaginationNumber from "@/domain/galleries/components/pagination/PaginationNumber.vue";
import PaginationInfinite from "@/domain/galleries/components/pagination/PaginationInfinite.vue";

export default {
  name: "VerticalMedias",
  components: {PaginationInfinite, PaginationNumber, Media},
  emits: ['nextPage', 'select'],
  props: {
    medias: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    paginationMode: {
      type: String,
      required: false
    },
    pagination: {
      type: Object,
      required: false
    },
    isPaid: {
      type: Boolean,
      required: false
    },
    digitalItemId: {
      type: Number,
      required: false
    },
    gallery: {
      type: Object,
      required: true
    }
  },
  computed: {
    paginationType() {
      return paginationType
    }
  },
  methods: {
    onPageChange(page) {
      this.$emit('nextPage', page)
    }
  }
}
</script>


<style>

</style>